import { IPartnerInfo } from '../../../models';

export const titles: Array<keyof IPartnerInfo> = [
	'adminCount',
	'partnerUserCount',
	'clientCount',
	'employeesCount',
];
